import { render, staticRenderFns } from "./ArticleItemView.vue?vue&type=template&id=7aa948f8&scoped=true&"
import script from "./ArticleItemView.vue?vue&type=script&lang=js&"
export * from "./ArticleItemView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItemView.vue?vue&type=style&index=0&id=7aa948f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa948f8",
  null
  
)

export default component.exports